import CategoryService from './service';

export * from './reqres';

export default CategoryService;
